<template>
  <!-- Functions are for admin only -->
  <div
    v-if="
      $store.state.app.user.indexOf($store.state.auth.uid) > -1 ||
      ($store.state.app.advanced.roles.admin &&
        $store.state.app.advanced.roles.admin.members &&
        $store.state.app.advanced.roles.admin.members.indexOf(
          $store.state.auth.uid
        ) > -1)
    "
  >
    <div class="flex wrap p4">
      <div class="container p4 flexy">
        <div class="flex column">
          <div class="flex between align-center">
            <!-- clear function creator -->
            <a
              class="update-text sm-font m8"
              @click="
                inputs.newfunction
                  ? $delete(inputs, 'newfunction') && $delete(inputs, 'newfunctionid')
                  : $set(
                      inputs,
                      'newfunction',
                      JSON.parse(JSON.stringify(models.function))
                    )
              "
            >
              <i class="fa fa-plus" />
            </a>
            <a
              class="update-text xs-font"
              @click="$set(show, 'import', !show.import)"
              >Import</a
            >
            <div v-if="show.import">
              <import
                type="function"
                :value="$store.state.app.advanced.functions"
                :obj="$store.state.app.advanced.functions"
              />
            </div>
            <span @click="debug = !debug" class="sm-font">
              <i class="fa fa-bug"></i> {{ debug ? "debug mode" : "" }}
            </span>
            <input
              type="search"
              v-model="inputs['search functions']"
              placeholder="Find function"
            />
          </div>

          <div class="flex wrap">
            <div class="flex column">
              <!-- Display saved functions -->
              <div
                v-for="(fn, functionkey) in functions"
                :key="functionkey"
                class="flex xs-font"
              >
                <div
                  :class="
                    show['customfunction' + functionkey]
                      ? 'update-border sub-container light-bg'
                      : ''
                  "
                  class="flex column"
                  v-if="
                    !inputs['search functions'] ||
                    JSON.stringify(fn)
                      .toLowerCase()
                      .includes(inputs['search functions'].toLowerCase())
                  "
                >
                  <span class="m4 flex align-center wrap"
                    ><a
                      class="border-bottom flex align-center"
                      @click="
                        $set(counters, fn.name + 'action', 0);
                        $set(
                          show,
                          'customfunction' + functionkey,
                          !show['customfunction' + functionkey]
                        );
                      "
                    >
                      <i class="fa fa-function black-text"></i>
                      <b class="l8 r8 update-text">{{
                        fn.name.toUpperCase()
                      }}</b>
                    </a>
                    <code @click="$copyText(fn.comment)" class="black-text">{{
                      fn.comment
                    }}</code>
                  </span>
                  <div
                    class="flex column p4"
                    v-if="show['customfunction' + functionkey]"
                  >
                    <action
                      :key="counters[fn.name + 'action']"
                      :name="fn.name"
                      :debug="debug"
                      :fun="functionkey || fn"
                    />
                    <div class="container p4 flex around align-center wrap">
                      <b
                        class="fa fa-edit"
                        @click="
                          inputs.newfunction
                            ? $delete(inputs, 'newfunction')
                            : $set(
                                inputs,
                                'newfunctionid',
                                functionkey
                              ), $set(
                                inputs,
                                'newfunction',
                                JSON.parse(JSON.stringify(fn))
                              )
                        "
                      ></b>
                      <rm
                        class="m4"
                        :name="functionkey"
                        :obj="$store.state.app.advanced.functions"
                        :fn="{
                          command: 'dispatch',
                          method: 'update',
                          type: 'app',
                          data: {data: $store.state.app},
                        }"
                      />
                      <!-- displays function model -->
                      <b
                        @click="
                          $set(
                            show,
                            'functionmodel' + functionkey,
                            !show['functionmodel' + functionkey]
                          )
                        "
                        >Model</b
                      >
                      <state
                        class="container indicate-border"
                        v-if="show['functionmodel' + functionkey]"
                        nesting="0"
                        editable="true"
                        :statedata="fn"
                      />
                      <a
                        @click="
                          fn.type = 'function';
                          exportfunction(fn);
                        "
                        >Export</a
                      >
                    </div>
                  </div>
                </div>

                <!-- <code>
                  {{ fn }}
                </code> -->
              </div>
            </div>

            <!-- Create and edit function configurator -->
            <div
              newfunction
              v-if="inputs.newfunction"
              class="p4 flexy sub-container"
              style="align-self: flex-start"
            >
              <div class="container p8">
                <span class="flex between align-center b8">
                  <span>
                    <b class="update-text md-font r4">{{
                      (
                        inputs["newfunction"].name || "New function "
                      ).toUpperCase()
                    }}</b>
                    <i>config</i>
                  </span>
                  <button
                    class="update m4 p8 sm-font flex align-center flex-end"
                    text="Save"
                    :disabled="
                      !(
                        inputs.newfunction &&
                        inputs.newfunction.name &&
                        inputs.newfunction.commands[0].method
                      )
                    "
                    type="button"
                    @click="
                      !$store.state.app.advanced.functions
                        ? ($store.state.app.advanced.functions = {})
                        : null;
                      $store
                        .dispatch('util', {
                          type: 'hash',
                          body: inputs.newfunction,
                        })
                        .then((h) => {
                          $set(
                            $store.state.app.advanced.functions,
                            h,
                            inputs.newfunction
                          );
                          inputs.newfunctionid && h !== inputs.newfunctionid
                            ? $set(
                                $store.state.app.advanced.functions,
                                inputs.newfunctionid, h
                              )
                            : null;
                          $set(inputs, 'newfunctionid', h);
                          $set(show, 'customfunction' + h, true)
                          $store
                            .dispatch('update', {
                              type: 'app',
                              data: $store.state.app,
                            })
                            .then(() => {
                              $set(
                                counters,
                                inputs.newfunction.name + 'action',
                                counters[
                                  inputs.newfunction.name + 'action'
                                ] + 1
                              );
                            });
                        });
                    "
                  >
                    <div><i class="fa fa-save" /> Save</div>
                  </button>
                </span>
                <div class="flex between container p8 b8">
                  <label class="flex column align-start">
                    <b class="xs-font">Function Name</b>
                    <input
                      placeholder="Function name"
                      type="text"
                      v-model="inputs.newfunction.name"
                    />
                  </label>
                  <label class="flex column align-start">
                    <b class="xs-font">Function Comment</b>
                    <input
                      type="text"
                      v-model="inputs.newfunction.comment"
                      placeholder="Function comment"
                    />
                  </label>
                </div>

                <div class="flex wrap column fill" v-if="inputs.newfunction">
                  <div class="flex column">
                    <!-- functions take expected inputs, this sets up types. note, in-app set's up their own types
                    TODO: remove input config and automatically add from custom functions like in-app -->
                    <div inputs class="flexy b16">
                      <div class="flex align-center between">
                        <b>Inputs</b>
                      </div>
                      <div class="xs-font update-border container">
                        <div
                          v-for="(input, inputkey) in inputs.newfunction
                            .inputs"
                          :key="inputkey"
                          class="container p4 border-bottom"
                        >
                          <div
                            class="flex align-center"
                            v-if="!show['editmodeinput' + inputkey]"
                          >
                            <b class="update-text p4">{{ inputkey }}</b>
                            <i class="m4">[ {{ input.type }} ]</i>
                            <rm
                              class="r8"
                              :obj="inputs.newfunction.inputs"
                              :name="inputkey"
                            />
                            <i
                              class="fa fa-edit update-text r4"
                              @click="
                                inputs['editinputname' + inputkey] = inputkey;
                                inputs['editinputtype' + inputkey] = input.type;
                                $set(show, 'editmodeinput' + inputkey, true);
                              "
                            />
                          </div>
                          <div v-else>
                            <div class="flex between align-center">
                              <span>
                                <input
                                  type="text"
                                  v-model="inputs['editinputname' + inputkey]"
                                />
                                <select
                                  v-model="inputs['editinputtype' + inputkey]"
                                >
                                  <option disabled>Input Type</option>
                                  <option
                                    :selected="opt === input.type"
                                    :value="opt"
                                    v-for="opt in [
                                      'string',
                                      'number',
                                      'boolean',
                                      'array',
                                      'object',
                                      'function',
                                    ]"
                                    :key="opt"
                                  >
                                    {{ opt }}
                                  </option>
                                </select>
                              </span>
                              <span
                                @click="
                                  $set(
                                    inputs.newfunction.inputs,
                                    inputs['editinputname' + inputkey],
                                    { type: inputs['editinputtype' + inputkey] }
                                  );
                                  inputs['editinputname' + inputkey] !==
                                  inputkey
                                    ? $delete(
                                        inputs.newfunction.inputs,
                                        inputkey
                                      )
                                    : $set(
                                        inputs.newfunction.inputs,
                                        inputkey,
                                        {
                                          type: inputs[
                                            'editinputtype' + inputkey
                                          ],
                                        }
                                      );
                                  inputs['editinputname' + inputkey] = '';
                                  inputs['editinputtype' + inputkey] = '';
                                  $set(show, 'editmodeinput' + inputkey, false);
                                "
                              >
                                <i class="fa fa-lg fa-save update-text" />
                              </span>
                              <rm
                                :name="inputkey"
                                :obj="inputs.newfunction.inputs"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="show['newinput']"
                          class="xs-font flex container p8 start wrap update"
                        >
                          <div class="flex column r8">
                            <label class="xs-font p4">Input Name</label>
                            <input
                              type="text"
                              placeholder="Input name"
                              v-model="inputs['newinputname']"
                            />
                            <code
                              class="warn p4"
                              v-if="
                                Object.keys(
                                  inputs.newfunction.inputs
                                ).indexOf(inputs['newinputname']) > -1 ||
                                !inputs['newinputname']
                              "
                              >Inputs must have unique names</code
                            >
                          </div>

                          <div>
                            <label class="xs-font">Input Type</label>
                            <select v-model="inputs['newinputtype']" class="m4">
                              <option
                                :value="opt"
                                v-for="opt in [
                                  'string',
                                  'number',
                                  'boolean',
                                  'array',
                                  'object',
                                  'function',
                                ]"
                                :key="opt"
                              >
                                {{ opt }}
                              </option>
                            </select>
                          </div>
                          <div>
                            <button
                              v-if="
                                Object.keys(
                                  inputs.newfunction.inputs
                                ).indexOf(inputs['newinputname']) === -1 &&
                                inputs['newinputtype'] &&
                                inputs['newinputname']
                              "
                              type="button"
                              class="update xs-font light-text p4"
                              @click="
                                $set(
                                  inputs.newfunction.inputs,
                                  inputs['newinputname'],
                                  { type: inputs['newinputtype'] }
                                );
                                inputs['newinputname'] = '';
                                inputs['newinputtype'] = '';
                                $set(show, 'newinput', false);
                              "
                            >
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                        <button
                          class="xs-font align-center update-text m4"
                          type="button"
                          @click="$set(show, 'newinput', true)"
                        >
                          <i class="fa fa-plus r4" /> Add input
                        </button>
                      </div>
                    </div>

                    <!-- functions are made of a sequence of commands -->
                    <div commands class="">
                      <div class="">
                        <div class="flex align-center between">
                          <b>Commands</b>
                        </div>

                        <!-- commands run in order of operations -->
                        <div
                          class="flex column"
                          v-if="
                            inputs.newfunction &&
                            inputs.newfunction.commands
                          "
                        >
                          <div
                            :class="!command.method && 'warn-border'"
                            class="
                              container
                              b8
                              flex
                              wrap
                              align-center
                              success-border
                            "
                            v-for="(command, commandi) in inputs.newfunction
                              .commands"
                            :key="commandi"
                          >
                            <div
                              :class="!command.method && 'warn'"
                              class="
                                xs-font
                                flexy
                                label
                                success
                                fit
                                p8
                                flex
                                wrap
                                align-center
                              "
                            >
                              <i
                                v-if="commandi > 0"
                                @click="
                                  inputs.newfunction.commands.splice(
                                    commandi - 1,
                                    0,
                                    inputs.newfunction.commands.splice(
                                      commandi,
                                      1
                                    )[0]
                                  )
                                "
                                class="fa-arrow-up fa fa-xs"
                              ></i>
                              <i class="lg-font m4">{{ commandi + 1 }}</i>
                              <i
                                v-if="
                                  commandi <
                                  inputs.newfunction.commands.length - 1
                                "
                                @click="
                                  inputs.newfunction.commands.splice(
                                    commandi + 1,
                                    0,
                                    inputs.newfunction.commands.splice(
                                      commandi,
                                      1
                                    )[0]
                                  )
                                "
                                class="fa fa-arrow-down fa-xs r8"
                              ></i>

                              <div class="flex align-center wrap">
                                <b
                                  @click="
                                    $set(
                                      show,
                                      'command.method' + commandi + 'config',
                                      !show[
                                        'command.method' + commandi + 'config'
                                      ]
                                    )
                                  "
                                  :class="!command.method && 'warn label'"
                                  class="lg-font r8"
                                  >{{
                                    command.method || "Undefined command"
                                  }}</b
                                >
                              </div>
                            </div>
                            <div class="flex flexy wrap align-center">
                              <span>
                                (
                                <i
                                  class="m4 sm-font"
                                  v-for="(a, ai) in command.inputs"
                                  :key="ai"
                                  >{{ ai }}
                                  <b>{{
                                    a.value == "static"
                                      ? ":" + a.static
                                      : ": " + a.value
                                  }}</b
                                  >,
                                </i>
                                )
                              </span>
                            </div>
                            <div
                              v-if="
                                show['command.method' + commandi + 'config']
                              "
                            >
                              <div
                                class="
                                  sm-font
                                  flex
                                  align-center
                                  p4
                                  between
                                  wrap
                                  m4
                                "
                              >
                                <div class="flex align-center">
                                  <label class="">
                                    <!-- select command type: app, custom, or another saved function  -->
                                    <debug
                                      name="command debug"
                                      :entry="command"
                                    />
                                    <b class="xs-font m4 align-center"
                                      >Command</b
                                    >
                                    <select v-model="command.type">
                                      <option selected disabled>
                                        Select Type
                                      </option>
                                      <option
                                        v-for="fntype in [
                                          'app',
                                          'custom',
                                          'user function',
                                        ]"
                                        :key="fntype"
                                        :value="fntype"
                                      >
                                        {{ fntype }}
                                      </option>
                                    </select>
                                  </label>
                                </div>
                                <div
                                  in-app
                                  class="flex align-center"
                                  appmethodtype
                                  v-if="command.type === 'app'"
                                >
                                  <div
                                    v-for="(method, methodname) in $store.state
                                      .functions"
                                    :key="methodname"
                                  >
                                    <!-- mapping magic via setnewfunction() -->
                                    <select
                                      required
                                      v-model="inputs[methodname]"
                                      @change="
                                        $store.state.functions[methodname][
                                          inputs[methodname]
                                        ].types
                                          ? $set(
                                              show,
                                              commandi + 'newargtypes',
                                              inputs[methodname]
                                            )
                                          : setnewfunction(
                                              commandi,
                                              methodname,
                                              inputs[methodname]
                                            )
                                      "
                                    >
                                      <option
                                        :value="funcname"
                                        v-for="(func, funcname) in method"
                                        :key="funcname"
                                      >
                                        {{ funcname }}
                                      </option>
                                    </select>
                                    <select
                                      required
                                      v-if="
                                        show[commandi + 'newargtypes'] &&
                                        $store.state.functions[methodname][
                                          inputs[methodname]
                                        ] &&
                                        $store.state.functions[methodname][
                                          inputs[methodname]
                                        ].types
                                      "
                                      v-model="inputs[commandi + 'newargtype']"
                                      @change="
                                        setnewfunction(
                                          commandi,
                                          methodname,
                                          inputs[methodname],
                                          inputs[commandi + 'newargtype']
                                        )
                                      "
                                    >
                                      <option
                                        v-for="(t, tk) in $store.state
                                          .functions[methodname][
                                          inputs[methodname]
                                        ].types"
                                        :key="tk"
                                        :value="tk"
                                      >
                                        {{ tk }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <label
                                  customfunction
                                  v-if="command.type === 'custom'"
                                >
                                  <b class="p4">Function</b>

                                  <!-- custom function are global js functions, i.e. alert, fetch, or console.log -->
                                  <input
                                    @blur="
                                      inputs.newfunction.state.outputs[
                                        commandi
                                      ] = {
                                        type: '',
                                        value: '',
                                      }
                                    "
                                    method
                                    class="xs-input"
                                    type="text"
                                    v-model="command.method"
                                    placeholder="JavaScript Function"
                                  />
                                </label>
                                <label class="flex align-start column">
                                  <div class="xs-font">Command comment</div>
                                  <textarea
                                    placeholder="Command comment"
                                    type="text"
                                    v-model="command.comment"
                                  />
                                </label>
                              </div>
                              <div
                                list-args
                                class="flex column container p4 m4 indicate"
                              >
                                <!-- configure custom function arguments -->
                                <div customarguments class="xs-font flexy">
                                  <b class="flex align-center">Arguments</b>
                                </div>
                                <div
                                  class="
                                    flex
                                    between
                                    align-center
                                    container
                                    sm-font
                                    border-bottom
                                  "
                                  :style="'order: ' + input.order"
                                  v-for="(input, inputkey) in command.inputs"
                                  :key="inputkey"
                                >
                                  <div class="flex align-center p4">
                                    <div
                                      class="indicate-text flex align-center"
                                    >
                                      <!-- assign inputs to args -->
                                      <b class="indicate-text p4">{{
                                        inputkey
                                      }}</b>
                                      <!-- set arg type -->
                                      <select v-model="input.type" class="l4">
                                        <option
                                          :selected="input.type"
                                          :value="opt"
                                          v-for="opt in [
                                            'string',
                                            'number',
                                            'boolean',
                                            'array',
                                            'object',
                                            'function',
                                          ]"
                                          :key="opt"
                                        >
                                          {{ opt }}
                                        </option>
                                      </select>
                                    </div>
                                    <span class="flex align-center wrap l4 r4">
                                      <i class="m4 fa fa-arrow-left"></i>
                                      <select class="m4" v-model="input.value">
                                        <!-- type checks before assignment -->
                                        <option
                                          :disabled="
                                            fninput.type !== input.type
                                          "
                                          :value="fninputkey"
                                          class="update-text"
                                          v-for="(
                                            fninput, fninputkey
                                          ) in inputs.newfunction.inputs"
                                          :key="fninputkey"
                                        >
                                          {{ fninputkey }} [{{ fninput.type }}]
                                        </option>
                                        <option
                                          :value="
                                            'state.outputs[' +
                                            stateoutputkey +
                                            ']'
                                          "
                                          class="update-text"
                                          v-for="(
                                            stateoutput, stateoutputkey
                                          ) in inputs[
                                            'newfunction'
                                          ].state.outputs.filter(
                                            (x, i) => i < commandi
                                          )"
                                          :key="stateoutputkey"
                                        >
                                          {{ stateoutputkey + 1 }}
                                          {{
                                            inputs["newfunction"].commands[
                                              stateoutputkey
                                            ].method
                                          }}
                                        </option>
                                        <option value="static">
                                          Static argument
                                        </option>
                                      </select>

                                      <!-- Static argument -->
                                      <div v-if="input.value === 'static'">
                                        <iinput
                                          v-model="input.static"
                                          :name="'static option'"
                                          :view="
                                            input.type === 'string' ||
                                            input.type === 'number'
                                              ? 'input' : 'json'
                                          "
                                        />
                                      </div>

                                      <!-- following allows for deep targeting of an object or array -->
                                      <i
                                        v-if="
                                          input.value.includes &&
                                          input.value.includes('state.outputs')
                                        "
                                        class="fa fa-bullseye m4 indicate-text"
                                        @click="
                                          $set(
                                            show,
                                            commandi + inputkey + 'target',
                                            !show[
                                              commandi + inputkey + 'target'
                                            ]
                                          )
                                        "
                                      />
                                      <iinput
                                        iinputfortarget
                                        class="v-scroll"
                                        :name="commandi + inputkey + 'target'"
                                        v-if="
                                          show[commandi + inputkey + 'target']
                                        "
                                        :select="commandi + inputkey + 'target'"
                                        v-model="input.target"
                                        type="text"
                                        placeholder="target"
                                      />
                                    </span>
                                  </div>

                                  <!-- set arg order -->
                                  <div class="flex align-center around">
                                    <span class="flex align-center">
                                      <i
                                        @click="
                                          $set(input, 'order', input.order - 1)
                                        "
                                        class="fa fa-arrow-up fa-sm"
                                      ></i>
                                      {{ input.order }}
                                      <i
                                        @click="
                                          $set(input, 'order', input.order + 1)
                                        "
                                        class="fa fa-arrow-down fa-sm"
                                      ></i>
                                    </span>
                                    <rm
                                      :name="inputkey"
                                      :obj="command.inputs"
                                    />
                                  </div>
                                </div>
                                <div
                                  v-if="show[commandi + 'addargument']"
                                  class="
                                    flex
                                    align-center
                                    between
                                    container
                                    p4
                                    border-bottom
                                    b4
                                  "
                                >
                                  <input
                                    type="text"
                                    v-model="inputs[commandi + 'newargname']"
                                    placeholder="Argument name"
                                  />
                                  <select
                                    argumenttypes
                                    v-model="inputs[commandi + 'newargtype']"
                                  >
                                    <option
                                      :value="opt"
                                      v-for="opt in [
                                        'string',
                                        'number',
                                        'boolean',
                                        'array',
                                        'object',
                                        'function',
                                      ]"
                                      :key="opt"
                                    >
                                      {{ opt }}
                                    </option>
                                  </select>
                                  <button
                                    type="button"
                                    :disabled="
                                      !(
                                        inputs[commandi + 'newargtype'] &&
                                        inputs[commandi + 'newargname']
                                      )
                                    "
                                    class="
                                      fa fa-plus fa-sm
                                      indicate
                                      p4
                                      flex
                                      align-center
                                    "
                                    @click="
                                      $set(
                                        inputs.newfunction.commands[commandi]
                                          .inputs,
                                        inputs[commandi + 'newargname'],
                                        {
                                          value: '',
                                          type: inputs[commandi + 'newargtype'],
                                          order: Object.keys(command.inputs)
                                            .length,
                                        }
                                      );
                                      $set(inputs, commandi + 'newargtype', '');
                                      $set(inputs, commandi + 'newargname', '');
                                      $set(
                                        show,
                                        commandi + 'addargument',
                                        false
                                      );
                                    "
                                  />
                                </div>
                              </div>
                              <div class="m4">
                                <button
                                  type="button"
                                  class="indicate-text xs-font b8"
                                  @click="
                                    $set(
                                      show,
                                      commandi + 'addargument',
                                      !show[commandi + 'addargument']
                                    )
                                  "
                                >
                                  <i class="fa fa-plus fa-xs r4"></i> Add
                                  argument
                                </button>
                              </div>

                              <!-- tests take a precongigured set of inputs and expected output, checks to match. other work already surpasses this in the hashtable commit -->
                              <div
                                test
                                class="
                                  xs-font
                                  container
                                  p4
                                  flex
                                  between
                                  wrap
                                  flexy
                                  t4
                                  update
                                  m4
                                "
                              >
                                <b
                                  class=""
                                  @click="
                                    $set(
                                      show,
                                      'test' + commandi,
                                      !show['test' + commandi]
                                    )
                                  "
                                  >Test</b
                                >
                                <div
                                  v-if="show['test' + commandi]"
                                  class="p4 container"
                                  style="align-self: flex-start"
                                >
                                  <!-- WHere was I? adding input options (manual entry, state select, function) to test functions. If a function is selected, then recur. Functions must take functions dammit i'm not a doctor, i'm a mornamns -->

                                  <div class="">
                                    <!-- TODO switch assign for iinputs or viceversa -->
                                    <assign
                                      :key="inputkey"
                                      v-for="(
                                        input, inputkey
                                      ) in command.inputs"
                                      :input="input"
                                      :inputkey="inputkey"
                                      :test="test"
                                    />
                                    {{ test }}
                                    <button
                                      type="button"
                                      @click="runtest(command, test, commandi)"
                                      class="light warn-text xs-font m4"
                                    >
                                      Test
                                    </button>
                                  </div>
                                  <div v-if="testresult[commandi]">
                                    <div class="flex wrap xs-font between">
                                      <b>Results</b>
                                      <i
                                        :class="
                                          ((Array.isArray(
                                            testresult[commandi]
                                          ) &&
                                            'array') ||
                                            typeof testresult[commandi]) ===
                                          inputs.newfunction.state.outputs[
                                            commandi
                                          ].type
                                            ? 'success-text'
                                            : 'warn-text'
                                        "
                                        >Type check:
                                        {{
                                          (Array.isArray(
                                            testresult[commandi]
                                          ) &&
                                            "array") ||
                                          typeof testresult[commandi]
                                        }}</i
                                      >
                                      <button
                                        class="success"
                                        type="button"
                                        @click="
                                          $set(command, 'tests', [
                                            test,
                                            testresult[commandi],
                                          ]);
                                          (test = {}),
                                            $delete(testresult, commandi);
                                        "
                                      >
                                        Save Test
                                      </button>
                                    </div>
                                    <code
                                      class="flex wrap column container p4"
                                      style="
                                        max-height: 300px;
                                        overflow: scroll;
                                        max-width: 300px;
                                      "
                                      >{{ testresult[commandi] }}</code
                                    >
                                  </div>
                                </div>
                              </div>
                              <rm
                                class="self-end fit p4"
                                :name="commandi"
                                :obj="inputs.newfunction.commands"
                              />
                            </div>
                          </div>
                          <div class="flex between">
                            <button
                              class="xs-font align-center success-text"
                              type="button"
                              @click="
                                $set(
                                  show,
                                  'command.method' +
                                    inputs.newfunction.commands.length +
                                    'config',
                                  true
                                );
                                inputs.newfunction.commands.push({
                                  method: '',
                                  inputs: {},
                                  type: '',
                                  tests: [],
                                });
                              "
                            >
                              <i class="fa fa-plus r4" /> Add command
                            </button>
                            <button
                              class="
                                update
                                m4
                                p8
                                sm-font
                                flex
                                align-center
                                flex-end
                              "
                              text="Save"
                              :disabled="
                                !(
                                  inputs.newfunction &&
                                  inputs.newfunction.name &&
                                  inputs.newfunction.commands[0].method
                                )
                              "
                              type="button"
                              @click="
                                !$store.state.app.advanced.functions
                        ? ($store.state.app.advanced.functions = {})
                        : null;
                      $store
                        .dispatch('util', {
                          type: 'hash',
                          body: inputs.newfunction,
                        })
                        .then((h) => {
                          $set(
                            $store.state.app.advanced.functions,
                            h,
                            inputs.newfunction
                          );
                          inputs.newfunctionid && h !== inputs.newfunctionid
                            ? $set(
                                $store.state.app.advanced.functions,
                                inputs.newfunctionid, h
                              )
                            : null;
                          $set(inputs, 'newfunctionid', h);
                          $set(show, 'customfunction' + h, true)
                          $store
                            .dispatch('update', {
                              type: 'app',
                              data: $store.state.app,
                            })
                            .then(() => {
                              $set(
                                counters,
                                inputs.newfunction.name + 'action',
                                counters[
                                  inputs.newfunction.name + 'action'
                                ] + 1
                              );
                            });
                        });
                              "
                            >
                              <div><i class="fa fa-save" /> Save</div>
                            </button>
                          </div>
                        </div>
                      </div>
                      <code v-if="$store.state.debug">{{
                        JSON.stringify(inputs["newfunction"], null, 2)
                      }}</code>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    functions () {
      return Object.fromEntries(Object.entries(this.$store.state.app.advanced.functions).filter(x=>typeof x[1] !== 'string'))
    }
  },
  data() {
    return {
      counters: {},
      debug: this.$store.state.debug,
      inputs: {},
      models: {
        function: {
          name: "",
          inputs: {},
          commands: [
            {
              method: "",
              inputs: {},
              type: "",
              tests: [],
            },
          ],
          output: {},
          test: ["inputs", "return value"],
          show: {},
          state: { outputs: [] }, // For holding output data
        },
      },
      testresult: {},
      show: {},
      test: {},
    };
  },
  methods: {
    exportfunction(fn) {
      this.$store.dispatch("export", fn);
    },
    setnewfunction(commandi, functiontype, name, type) {
      this.inputs.newfunction.commands[commandi].inputs = {};
      let typesobject =
        (this.$store.state.functions[functiontype][name].types &&
          this.$store.state.functions[functiontype][name].types[type]
            .payload) ||
        (Object.keys(this.$store.state.functions[functiontype][name].payload)
          .length > 0 &&
          this.$store.state.functions[functiontype][name].payload) ||
        {};
      let command = this.inputs.newfunction.commands[commandi];
      this.$set(
        this.inputs.newfunction.commands[commandi],
        "inputs",
        command.type == "app"
          ? this.$store.state.functions[functiontype][name].types &&
            this.$store.state.functions[functiontype][name].types[type].payload
            ? {
                type,
                ...this.$store.state.functions[functiontype][name].types[type]
                  .payload,
              }
            : this.$store.state.functions[functiontype][name].payload || {}
          : {}
      );

      // method name is function call denoted by [type.method], i.e. dispatch.api or mutation.set
      this.$set(
        this.inputs.newfunction.commands[commandi],
        "method",
        functiontype + "." + name
      );

      // sets up output object for command
      this.$set(this.inputs.newfunction.state.outputs, commandi, {
        type: "",
        value: "",
      });

      // maps config inputs to command inputs
      command.inputs = {};
      if (
        Object.entries(this.inputs.newfunction.inputs).length > 0 &&
        commandi > 0
      ) {
        confirm("Remove function inputs?")
          ? (this.inputs.newfunction.inputs = {})
          : null;
      } else {
        this.inputs.newfunction.inputs = {};
      }
      Object.keys(typesobject).map((x, i) => {
        // input type set. if a function, then fire it bc it's either String(), Number()
        // check if it's an array, else set whatever type it is.
        let thistype =
          typeof typesobject[x] !== "function"
            ? Array.isArray(typesobject[x])
              ? "array"
              : typeof typesobject[x]
            : typeof typesobject[x]();
        // sets inputs on model
        if (
          Object.keys(this.inputs.newfunction.inputs).length <
          Object.keys(typesobject).length
        ) {
          this.$set(this.inputs.newfunction.inputs, x, { type: thistype });
          this.$set(this.inputs.newfunction.commands[commandi].inputs, x, {
            order: i,
            type: thistype,
            value: x,
          });
        }
        // finally sets command.inputs to empty value of given type fn, i.e. String() else defaults to empty string
        this.$set(command.inputs, x, {
          order: i + 1,
          static:
            typesobject[x] && typeof typesobject[x] !== "function"
              ? typesobject[x]
              : false,
          value:
            typeof typesobject[x] === "function"
              ? typesobject[x]()
              : command.type == "app"
              ? "static"
              : typesobject[x] || "",
          type: thistype,
        });
      });
      // Special case for app functions that expect a static type
      command.type === "app" &&
      this.$store.state.functions[functiontype][name].types
        ? this.$set(command.inputs, "type", {
            order: Object.keys(typesobject).length + 1,
            static: type,
            value: "static",
            type: "string",
          })
        : null;
    },
    runtest(command, test, i) {
      let method = command.method.split(".")[0];
      let type = command.method.split(".")[1];
      command.type === "app" &&
        this.$store[method](type, test).then((d) =>
          this.$set(this.testresult, i, d)
        );
    },
    savetest() {},
  },
};
</script>